module.exports = __webpack_public_path__ + "img/account.3cb42e1c.svg";